import { styled } from '@linaria/react';
import { fonts, radius, semantic, space } from '../theme/tokens';

export const IconWrapper = styled.span`
  position: relative;
  display: inline-flex;
`;

export const Badge = styled.span`
  position: absolute;
  top: -${space['space-200']};
  right: -${space['space-200']};
  background: ${semantic.bg.brand};
  color: ${semantic.text.inverse};
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.bold};
  min-width: ${space['space-400']};
  height: ${space['space-400']};
  border-radius: ${radius('chip', 'radius-full')};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${space['space-100']};
  line-height: 1;
`;
